import { Box } from "@chakra-ui/react";
import { useMemo, useEffect } from "react";
import { useAPI } from "../api/useAPI";
import { useAPIQuery } from "../api/useAPIQuery";
import { useToastOnAPIError } from "../api/useToastOnAPIError";
import { TeamCard } from "../team/TeamCard";
import { SkeletonList } from "../utils/SkeletonList";
import { NoItemCard } from "../utils/NoItemCard";
import { ManageItemsWidget } from "../utils/ManageItemsWidget";
import { useNavigate } from "react-router-dom";

export const TeamsPanel = () => {
  const api = useAPI();
  const {
    data: teamGetData,
    state: teamGetState,
    error: teamGetError,
    query: teamGetQuery,
  } = useAPIQuery({ apiCall: api.teamGet });
  useToastOnAPIError({
    error: teamGetError,
    title: `Unable to get teams`,
  });
  const navigate = useNavigate();

  const teams = useMemo(() => teamGetData?.teams ?? [], [teamGetData?.teams]);

  useEffect(() => {
    teamGetQuery({});
  }, [teamGetQuery]);

  return (
    <Box width={"100%"} minHeight={8}>
      <ManageItemsWidget
        title="Teams"
        onNewItemClick={() => navigate("/team/new")}
      />
      {teamGetState === "success" ? (
        <Box>
          {teams.length > 0 ? (
            teams.map((team) => <TeamCard key={team.id} team={team} />)
          ) : (
            <NoItemCard
              description="No teams exist"
              buttonText="Create Team"
              navigateUrl="/team/new"
            />
          )}
        </Box>
      ) : (
        <SkeletonList height={20} items={3} />
      )}
    </Box>
  );
};
